import { TPlanCode } from "@/types/TSubscription";

/** `?plan=` from the site, kept until the account is set up. */
export const PLAN_INTENT_KEY = "subscription:intent";

const PUBLIC_PLANS: TPlanCode[] = ["user", "user_plus", "team", "team_plus"];

/** A plan code the site may hand over; anything else is ignored. */
export const asPlanIntent = (value: string | null): TPlanCode | null =>
	value && (PUBLIC_PLANS as string[]).includes(value)
		? (value as TPlanCode)
		: null;

/** Remember the plan the visitor picked on the site, for after the onboarding. */
export const rememberPlanIntent = (value: string | null): void => {
	const plan = asPlanIntent(value);
	if (!plan) return;
	try {
		sessionStorage.setItem(PLAN_INTENT_KEY, plan);
	} catch {
		// Private window: they will find the plans in the profile.
	}
};

/** The remembered plan, read once and forgotten. */
export const takePlanIntent = (): TPlanCode | null => {
	try {
		const plan = asPlanIntent(sessionStorage.getItem(PLAN_INTENT_KEY));
		sessionStorage.removeItem(PLAN_INTENT_KEY);
		return plan;
	} catch {
		return null;
	}
};
